import { services } from '@repo/ui/lib/api/services/index';
import { useMutation, useQueryClient } from '@tanstack/react-query';
//@ts-ignore
import { SignUpData } from '@repo/ui/lib/api/types/auth';
import { safeSetItem } from '../../../lib/utils/localStorage';
import { useRouter } from '../../use-router';

export function useAuth() {
  const queryClient = useQueryClient();
  const router = useRouter();
  const auth = services.auth;

  const loginMutation = useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      auth.login(email, password),
    onSuccess: (response) => {
      console.log({ response })
      safeSetItem('token', response.data.token);
      queryClient.invalidateQueries();
      router.push('/admin/dashboard');
    },
    onError: (error: any) => {
      console.error('Login mutation error:', error);
      // The error will be propagated to the component via mutateAsync
    },
  });

  const signUpMutation = useMutation({
    mutationFn: (data: SignUpData) => auth.signUp(data),
    onSuccess: () => {
      router.push('/auth/login');
    },
  });

  const resetPasswordMutation = useMutation({
    mutationFn: ({
      id,
      password,
      confirmPassword,
    }: {
      id: string;
      password: string;
      confirmPassword: string;
    }) => auth.resetPassword(id, password, confirmPassword),
  });

  const sendResetPasswordEmailMutation = useMutation({
    mutationFn: (email: string) => auth.sendEmailResetPassword(email),
  });

  const logout = () => {
    auth.logout();
    queryClient.clear();
    router.push('/auth/login');
  };

  return {
    login: loginMutation.mutateAsync,
    isLoggingIn: loginMutation.isPending,
    loginError: loginMutation.error,
    signUp: signUpMutation.mutate,
    isSigningUp: signUpMutation.isPending,
    resetPassword: resetPasswordMutation.mutate,
    isResettingPassword: resetPasswordMutation.isPending,
    sendResetPasswordEmail: sendResetPasswordEmailMutation.mutate,
    isSendingResetEmail: sendResetPasswordEmailMutation.isPending,
    logout,
    isAdmin: auth.isAdmin(),
    isVisiteur: auth?.isVisiteur(),
    isDendro: auth.isDendro(),
    isAgile: auth.isAgile(),
    isAgent: auth.isAgent(),
    isRoleDeleted: auth.isRoleDeleted(),
  };
}
